import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { AuthUser } from '@app/core/models/auth-user';
import { SecurityPermissionName } from '@app/core/models/permission';
import { DialogComponent } from '@app/shared/dialog/dialog-component.directive';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'portal-auth-user-info-dialog',
  templateUrl: './auth-user-info-dialog.component.html',
  styles: [],
  standalone: false,
})
export class AuthUserInfoDialogComponent extends DialogComponent<void, void> implements OnInit {
  authUser$!: Observable<AuthUser>;

  permissions: SecurityPermissionName[] = [];
  query: string = '';

  constructor(
    private authenticationService: AuthenticationService,
    ngbActiveModal: NgbActiveModal
  ) {
    super(ngbActiveModal);
  }

  ngOnInit(): void {
    this.authUser$ = this.authenticationService.authUser$.pipe(untilDestroyed(this));

    this.updateFilter('');
  }

  updateFilter(query: string): void {
    this.query = query;

    this.authUser$.pipe(first()).subscribe((authUser) => {
      this.permissions = authUser.role.permissions
        .filter((permission) => permission.toLowerCase().includes(this.query.toLowerCase()))
        .sort((a, b) => a.localeCompare(b)) as SecurityPermissionName[];
    });
  }
}
